import { useEffect, useRef } from 'react';
import { dispatchSignupWithPolicy, getSignupPolicyError, isSignupPolicyReady } from '../helpers/signupPolicy.js';

// Own one normal-signup view and reject a policy read that outlives that view.
export const useSignupPolicy = ({ settings, isLoading = false, active = true }) => {
  const owner = useRef({ settings, isLoading, active });
  const alive = useRef(true);
  if (owner.current.settings?.use_date_of_birth !== settings?.use_date_of_birth || owner.current.isLoading !== isLoading || owner.current.active !== active) {
    owner.current = { settings, isLoading, active };
  }
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  return {
    ready: active && isSignupPolicyReady(settings, isLoading),
    async submit(values, payload, readSettings, dispatch) {
      const current = owner.current;
      if (!alive.current || !current.active) return null;
      const error = getSignupPolicyError(values, current.settings, current.isLoading);
      if (error) throw new Error(error);
      return dispatchSignupWithPolicy({ values, payload, readSettings, dispatch,
        isCurrent: () => alive.current && owner.current === current && current.active });
    },
  };
};
